/** Direction describes movement; valence is an explicit domain decision. */
export type TrendValence = 'favourable' | 'adverse' | 'neutral';
export const trendValenceClasses: Record<TrendValence, string> = {
  favourable: 'text-status-success-fg bg-status-success-bg',
  adverse: 'text-status-danger-fg bg-status-danger-bg',
  neutral: 'text-status-neutral-fg bg-status-neutral-bg',
};
